'use client';

import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';
import { DEFAULT_CURRENCIES } from '@/helpers/currency';
import { QUERY_VIP } from '@/helpers/modals';
import { getCurrencyCentsAndCode } from '@/helpers/wallet';
import { DEFAULT_AMOUNTS } from '@/modules/deposit';
import { useGetCommonStore } from '@/store';

const PRICE_GAP = 1;

export const useABIncreasePrevDep = () => {
  const useCommonStore = useGetCommonStore();

  const user = useCommonStore.use.user();
  const currentWallet = useCommonStore.use.currentWallet();

  const searchParams = useSearchParams();

  const lastSuccessfulPaymentsByCurrency =
    useCommonStore.use.lastSuccessfulPaymentsByCurrency();
  const pending = useCommonStore.use.lastSuccessfulPaymentsByCurrencyPending();

  const { transactionSum } = useMemo(() => {
    if (!user || searchParams.get(QUERY_VIP)) {
      return {
        transactionSum: 0,
      };
    }

    const defaultSum = DEFAULT_AMOUNTS[user.currency];
    const amountCents = lastSuccessfulPaymentsByCurrency[user.currency] || 0;

    const transactionSum = getCurrencyCentsAndCode(
      amountCents,
      user.currency,
      DEFAULT_CURRENCIES
    ).amount;

    return {
      turnOffTest: transactionSum < defaultSum + PRICE_GAP,
      transactionSum,
    };
  }, [searchParams, lastSuccessfulPaymentsByCurrency, user?.currency]);

  const increasedPrevDepValue = useMemo(() => {
    if (!currentWallet?.isCrypto) {
      return transactionSum;
    }
    return 0;
  }, [currentWallet, transactionSum]);

  return {
    transactionSum,
    transactionPending: pending,
    increasedPrevDepValue,
  };
};
